import { lazy } from 'react';



const HomeComponent = lazy(() => import('../modules/Home')),
    CareHomeComponent = lazy(() => import('../modules/Home/careDailyHome')),
    PagesComponent = lazy(() => import('../modules/Pages')),
    SignInComponent = lazy(() => import('../modules/Common/LoginSignUp/LoginSignUp.jsx')),
    LoginPageComponent = lazy(() => import('../modules/Common/LoginSignUp/LoginPage.jsx')),
    SitemapComponent = lazy(() => import('../modules/Common/Footer/Sitemap/Sitemap.jsx')),
    AccessibilityComponent = lazy(() => import('../modules/Common/Footer/Accessibility/Accessibility.jsx')),
    CookieSettingsComponent = lazy(() => import('../modules/Common/Footer/CookieSettings/CookieSettings.jsx')),
    StatusPageComponent = lazy(() => import('../modules/Common/Footer/StatusPage/StatusPage.jsx')),
    // SubscriptionListComponent = lazy(() => import('../modules/Subscriptions/SubscriptionList')),
    SubscriptionListComponent = lazy(() => import('../modules/Subscriptions/SubscriptionList/modernList.js')),
    // SubscriptionDetailComponent = lazy(() => import('../modules/Subscriptions/SubscriptionDetail')),
    SubscriptionDetailComponent = lazy(() => import('../modules/Subscriptions/SubscriptionDetail/newIndex.js')),
    PackageListComponent = lazy(() => import('../modules/Home/Search')),
    PackageDetailComponent = lazy(() => import('../modules/ProductDetail')),
    DocumentSearchComponent = lazy(() => import('../modules/Home/DocumentSearch')),
    CartComponent = lazy(() => import('../modules/Cart')),
    CheckoutComponent = lazy(() => import('../modules/Checkout')),
    OrderComponent = lazy(() => import('../modules/Orders')),
    OrderDetailsComponent = lazy(() => import('../modules/Orders/Details')),
    DashboardComponent = lazy(() => import('../modules/Dashboard/newDashboard.jsx')),
    RecentUpdatesComponent = lazy(() => import('../modules/Documents/RecentUpdates')),
    DocumentCompareComponent = lazy(() => import('../modules/Documents/DocumentCompare')),
    DocumentListComponent = lazy(() => import('../modules/Documents/ListDocument')),
    DocumentEditorComponent = lazy(() => import('../modules/Documents/DocumentEditor')),
    UserSubscriptionListComponent = lazy(() => import('../modules/Subscriptions/PlanSubscription')),
    // UserSubscriptionListComponent = lazy(() => import('../modules/Subscriptions/NewSubscription')),
    SubscriptionPayComponent = lazy(() => import('../modules/Subscriptions/Payment')),
    UsersListComponent = lazy(() => import('../modules/Users')),
    EmployeeGroups = lazy(() => import('../modules/EmployeeGroups')),
    AddGroupComponent = lazy(() => import('../modules/EmployeeGroups/AddGroup')),
    EditGroupComponent = lazy(() => import('../modules/EmployeeGroups/EditGroup')),
    ViewGroupComponent = lazy(() => import('../modules/EmployeeGroups/ViewGroup')),
    EmployeePolicies = lazy(() => import('../modules/EmployeePolicies')),
    AddPolicy = lazy(() => import('../modules/EmployeePolicies/Add')),
    EditPolicy = lazy(() => import('../modules/EmployeePolicies/Edit')),
    UserAddComponent = lazy(() => import('../modules/Users/Add')),
    UserEditComponent = lazy(() => import('../modules/Users/Edit')),
    ViewUserComponent = lazy(() => import('../modules/Users/View')),
    USERSACTIVTYCOMPONENT = lazy(() => import('../modules/Users/Activity')),
    UserDeleteComponent = lazy(() => import('../modules/Users/Deleted')),
    // EmployeePolicyDocuments = lazy(() => import('../modules/EmployeePolicies/UserPolicyDocuments')),
    IndexComponent = lazy(() => import('../modules/Documents/IndexPage')),
    SettingsComponent = lazy(() => import('../modules/Users/settings/index')),
    NoMatchComponent = lazy(() => import('../modules/NoMatch')),
    PDF_EXPIRE_DOCUMENT = lazy(() => import('../modules/pdf_viwer')),
    SAVED_DOCUMENTS = lazy(() => import('../modules/Documents/saved-documents')),
    CREATE_NEW_SAVED_DOCS = lazy(() => import('../modules/Documents/create_editor')),
    OrderHistory = lazy(() => import('../modules/Orders/OrderHistory')),
    New_Profile = lazy(() => import('../modules/MyProfile')),
    ContactUs = lazy(() => import('../modules/Contact/ContactUs')),
    // AboutUs = lazy(() => import('../modules/Common/AboutUs/index.js')),
    AboutUs = lazy(() => import('../modules/Common/AboutUs/aboutUs.jsx')),
    Features = lazy(() => import('../modules/Features/Features')),
    Pricing = lazy(() => import('../modules/Common/PricingLanding/PricingLanding.jsx')),
    AllinOnePricing = lazy(() => import('../modules/Common/AllinOnePricing/AllInOnePricing.js')),
    CareManagementPricing = lazy(() => import('../modules/Common/CareManagementPricing/CareManagementPricing.jsx')),
    CaseStudies = lazy(() => import('../modules/Common/CaseStudies/CaseStudies.jsx')),
    Security = lazy(() => import('../modules/Common/Security/Security.jsx')),
    Updates = lazy(() => import('../modules/Common/Updates/Updates.jsx')),
    RoadMap = lazy(() => import('../modules/Common/ProductRoadMap/ProductRoadmap.jsx')),
    Knowledge = lazy(() => import('../modules/Knowledge Base/index')),
    DocManagementPayment = lazy(() => import('../modules/Subscriptions/DocManagementPayment')),
    FreeDocumentDownload = lazy(() => import('../modules/FreePolicies')),
    ViewInvoiceDetails = lazy(() => import('../modules/Subscriptions/Invoice/ViewInvoice')),
    NeedReviewList = lazy(() => import('../modules/Documents/NeedReviewList')),
    DocumentUpdate = lazy(() => import('../modules/Documents/DocumentUpdate')),
    UptoDateDocuments = lazy(() => import('../modules/Documents/UptoDateDocuments')),
    EmployeesListComponent = lazy(() => import('../modules/Employees')),
    AddEmployeeComponent = lazy(() => import('../modules/Employees/Add')),
    DeletedEmployeesComponent = lazy(() => import('../modules/Employees/DeletedList')),
    EditEmployeeComponent = lazy(() => import('../modules/Employees/Edit')),
    ViewEmployeeComponent = lazy(() => import('../modules/Employees/View')),
    ViewDocument = lazy(() => import('../modules/Subscriptions/ViewDocument')),
    // HistoryList = lazy(() => import('../modules/History')),
    ReferenceDocView = lazy(() => import('../modules/Documents/DocumentEditor/ReferenceDocumentView')),
    ForgotPassword = lazy(() => import('../modules/ForgotPassword/ForgotPassword')),
    Otpverification = lazy(() => import('../modules/ForgotPassword/Otpverification')),
    ResetPassword = lazy(() => import('../modules/ForgotPassword/resetpassword')),
    LoginComponent = lazy(() => import('../modules/Login')),
    MyfilesComponent = lazy(() => import('../modules/Myfiles/index')),
    MyfileEditorComponent = lazy(() => import('../modules/Myfiles/MyfileEditor')),
    MyfileDetailsComponent = lazy(() => import('../modules/Myfiles/MyfilesDetails')),
    MyDocumentsComponent = lazy(() => import('../modules/MyDocuments/index')),
    MyDocumentsEditorComponent = lazy(() => import('../modules/MyDocuments/MyfileEditor')),
    MyDocumentsDetailsComponent = lazy(() => import('../modules/MyDocuments/MyfilesDetails')),
    PublishedPolicies = lazy(() => import('../modules/PublishedPolicies')),
    PublicPolicies = lazy(() => import('../modules/PublicPolicies')),
    ViewPolicy = lazy(() => import('../modules/PublicPolicies/ViewPolicy')),
    AddMultiPolicy = lazy(() => import('../modules/EmployeePolicies/Add/MultipleDocument')),
    DocumentBinComponent = lazy(() => import('../modules/Documents/Bin')),
    KnowledgeBase = lazy(() => import('../modules/Knowledge Base/index')),
    VideoPage = lazy(() => import('../modules/Knowledge Base/index-2')),


    //doc sign
    DocSign = lazy(() => import('../modules/DocumentSign/sign')),
    DocSignSuccess = lazy(() => import('../modules/DocumentSign/SuccessPage')),
    //Dyanamic FAQ
    FAQComponent = lazy(() => import('../modules/FAQ/faq')),
    //course
    CourseComponent = lazy(() => import('../modules/Course/courseList')),

    //Documentation
    Documentation = lazy(() => import('../modules/Documentation/view')),
    DocumentLibrary = lazy(() => import('../modules/Subscriptions/DocumentLibrary/dataList.js')),
    ReadyTousePolicy = lazy(() => import('../modules/Subscriptions/SubscriptionDetail/KnowMore/readyTousePolicy')),
    UptoDateDocumentsPricing = lazy(() => import('../modules/Subscriptions/SubscriptionDetail/KnowMore/uptoDateDocuments')),
    FlexiblePricing = lazy(() => import('../modules/Subscriptions/SubscriptionDetail/KnowMore/flexiblePricing'));

const FormList = lazy(() => import('../modules/FormBuilder/formList'));
const FormBuilder = lazy(() => import('../modules/FormBuilder/form.js'));
const WebForm = lazy(() => import('../modules/FormBuilder/webForm.js'));
const companyForm = lazy(() => import('../modules/FormBuilder/companyForm.js'));
const successPage = lazy(() => import('../modules/FormBuilder/successPage.js'));
const CourseCheckout = lazy(() => import('../modules/Subscriptions/PlanSubscription/CourseSelect/CourseCheckout'));
const ChecklistNew = lazy(() => import('../modules/CheckList/newProvider.js'));

// care management header routes 
const carePlanning = lazy(() => import('../modules/CareManagement/CarePlanning.jsx'));
const Assessments = lazy(() => import('../modules/CareManagement/Assessments.jsx'));
const DailyLogs = lazy(() => import('../modules/CareManagement/DailyLogs.jsx'));
const EmarSysytem = lazy(() => import('../modules/CareManagement/EMAR.jsx'));
const VisitsRostering = lazy(() => import('../modules/CareManagement/VisitRostering.jsx'));
const Routeplanning = lazy(() => import('../modules/CareManagement/RoutePlanning.jsx'));
const ClockInOut = lazy(() => import('../modules/CareManagement/ClockInOut.jsx'));
const FinanceBilling = lazy(() => import('../modules/CareManagement/FinanceBilling.jsx'));
const StaffApp = lazy(() => import('../modules/CareManagement/StaffApp.jsx'));
const FamilyApp = lazy(() => import('../modules/CareManagement/FamilyApp.jsx'));
const MediaNotes = lazy(() => import('../modules/CareManagement/MediaNotes.jsx'));
const Training = lazy(() => import('../modules/CareManagement/Training.jsx'));
const LearningHub = lazy(() => import('../modules/CareManagement/LearningHub.jsx'));
const SkillsMatrix = lazy(() => import('../modules/CareManagement/SkillsMatrix.jsx'));
const HelpCenter = lazy(() => import('../modules/Common/HelpCenter/HelpCentre.jsx'));
// const ContactSupport = lazy(() => import('../modules/Common/ContactSupport/ContactSupport.jsx'));
const SystemStatus = lazy(() => import('../modules/Common/SystemStatus/SystemStatus.jsx'));
const ProductTours = lazy(() => import('../modules/Common/ProductTours/ProductTours.jsx'));
const Partners = lazy(() => import('../modules/Common/Partners/Partners.jsx'));
const Documentation_Footer = lazy(() => import('../modules/Common/Documentation_Footer/Documentation.jsx'));
const Community = lazy(() => import('../modules/Common/Community/Community.jsx'));
const Document_Vault = lazy(() => import('../modules/Common/DocumentVault/DocumentVault.jsx'));
const Smart_Editor = lazy(() => import('../modules/Common/SmartEditor/SmartEditor.jsx'));
const Compliance_Calender = lazy(() => import('../modules/Common/ComplianceCalender/ComplianceCalendar.jsx'));
const Export_Print = lazy(() => import('../modules/Common/ExportPrint/ExportPrint.jsx'));
const Update_Alert = lazy(() => import('../modules/Common/UpdateAlerts/UpdateAlerts.jsx'));
const Team_Access = lazy(() => import('../modules/Common/TeamAccess/TeamAccess.jsx'));




// for test the new design using with ai
const StaffViewRemote = lazy(() => import('../mfe/index.js'));
const PreviewAICode = lazy(() => import("../mfe/index.js"))

const StaffAddEditRemote = lazy(() => import('../mfe/index.js'));
const StaffListRemote = lazy(() => import('../mfe/index.js'))

const RemoteApp = lazy(() => import('../mfe/index.js'))


//  HomeComponent = lazy(() => import('../modules/Home/new-home')), 
// SubscriptionDetailComponent = lazy(() => import('../modules/Subscriptions/SubscriptionDetail/newsubscriptiondetails_copy')),
// ViewSubscriptions = lazy(() => import('../modules/Subscriptions/NewSubscription/ViewSubscriptions'));
// const HomeComponent = lazy(() => import('../modules/Home'));
// DocumentPreview = lazy(() => import('../modules/Pages/DocumentPreview')),
// resetpassword = lazy(() => import('../modules/ForgotPassword/resetpassword')),
// const LoginComponent = lazy(() => import('../modules/Login'));
// const RegisterComponent = lazy(() => import('../modules/Signup'));
// const RegisterComponent = lazy(() => import('../modules/Signup/new-sign-up'));
// const ProfileComponent = lazy(() => import('../modules/MyProfile'));
// const SubscriptionListComponent = lazy(() => import('../modules/Subscriptions/SubscriptionList'));
// const SubscriptionListComponent = lazy(() => import('../modules/Subscriptions/SubscriptionList/new-subscription-list'));
// const SubscriptionDetailComponent = lazy(() => import('../modules/Subscriptions/SubscriptionDetail/newsubscriptiondetails'));
// const CartComponent = lazy(() => import('../modules/Cart'));
// const CheckoutComponent = lazy(() => import('../modules/Checkout'));
// const CheckoutComponent = lazy(() => import('../modules/Checkout/NewCheckout'));
// const UserSubscriptionListComponent = lazy(() => import('../modules/Subscriptions'));

const routes = [
    { 'path': '/', 'component': CareHomeComponent, 'exact': true, 'private': false },
    { 'path': '/caredaily', 'component': CareHomeComponent, 'exact': true, 'private': false },
    { 'path': '/getstarted', 'component': SignInComponent, 'exact': true, 'private': false },
    { 'path': '/login', 'component': LoginPageComponent, 'exact': true, 'private': false },

    { 'path': '/status', 'component': StatusPageComponent, 'exact': true, 'private': false },
    { 'path': '/cookie-settings', 'component': CookieSettingsComponent, 'exact': true, 'private': false },
    { 'path': '/accessibility', 'component': AccessibilityComponent, 'exact': true, 'private': false },
    { 'path': '/sitemap', 'component': SitemapComponent, 'exact': true, 'private': false },



    // { 'path': '/login', 'component': LoginComponent, 'exact': true, 'private': false },
    { 'path': '/forgotpassword', 'component': ForgotPassword, 'exact': true, 'private': false },
    { 'path': '/verifyotp', 'component': Otpverification, 'exact': true, 'private': false },
    { 'path': '/resetpassword', 'component': ResetPassword, 'exact': true, 'private': false },
    { 'path': '/company/knowledge', 'component': KnowledgeBase, 'exact': true, 'private': false },
    { 'path': '/company/knowledge/video', 'component': VideoPage, 'exact': true, 'private': false },
    // { 'path': '/employee/login', 'component': EmployeeLogin, 'exact': true, 'private': false },
    // { 'path': '/employee/register', 'component': EmployeeSignUp, 'exact': true, 'private': false },
    { 'path': '/pages/:slug', 'component': PagesComponent, 'exact': true, 'private': false },
    { 'path': '/policies-procedures', 'component': SubscriptionListComponent, 'exact': true, 'private': false },
    { 'path': '/care-planning', 'component': carePlanning, 'exact': true, 'private': false },
    { 'path': '/assessments', 'component': Assessments, 'exact': true, 'private': false },
    { 'path': '/daily_logs', 'component': DailyLogs, 'exact': true, 'private': false },
    { 'path': '/emar-system', 'component': EmarSysytem, 'exact': true, 'private': false },
    { 'path': '/visit-rostering', 'component': VisitsRostering, 'exact': true, 'private': false },
    { 'path': '/routeplan', 'component': Routeplanning, 'exact': true, 'private': false },
    { 'path': '/clock-in-out', 'component': ClockInOut, 'exact': true, 'private': false },
    { 'path': '/finance-billing', 'component': FinanceBilling, 'exact': true, 'private': false },
    { 'path': '/staff-app', 'component': StaffApp, 'exact': true, 'private': false },
    { 'path': '/family-app', 'component': FamilyApp, 'exact': true, 'private': false },
    { 'path': '/media-notes', 'component': MediaNotes, 'exact': true, 'private': false },
    { 'path': '/training', 'component': Training, 'exact': true, 'private': false },
    { 'path': '/learning-hub', 'component': LearningHub, 'exact': true, 'private': false },
    { 'path': '/skills-matrix', 'component': SkillsMatrix, 'exact': true, 'private': false },
    { 'path': '/help-centre', 'component': HelpCenter, 'exact': true, 'private': false },
    // { 'path': '/contact-support', 'component': ContactSupport, 'exact': true, 'private': false },
    { 'path': '/system-status', 'component': SystemStatus, 'exact': true, 'private': false },
    { 'path': '/product-tours', 'component': ProductTours, 'exact': true, 'private': false },
    { 'path': '/partners', 'component': Partners, 'exact': true, 'private': false },
    { 'path': '/documentation', 'component': Documentation_Footer, 'exact': true, 'private': false },
    { 'path': '/document-vault', 'component': Document_Vault, 'exact': true, 'private': false },
    { 'path': '/smart-editor', 'component': Smart_Editor, 'exact': true, 'private': false },
    { 'path': '/compliance-calendar', 'component': Compliance_Calender, 'exact': true, 'private': false },
    { 'path': '/export-print', 'component': Export_Print, 'exact': true, 'private': false },
    { 'path': '/team-access', 'component': Team_Access, 'exact': true, 'private': false },
    { 'path': '/update-alerts', 'component': Update_Alert, 'exact': true, 'private': false },
    { 'path': '/community', 'component': Community, 'exact': true, 'private': false },
    { 'path': '/subscription-detail/:slug', 'component': SubscriptionDetailComponent, 'exact': true, 'private': false },
    { 'path': '/package-search', 'component': PackageListComponent, 'exact': true, 'private': false },
    { 'path': '/package-detail/:slug', component: PackageDetailComponent, 'exact': true, 'private': false },
    { 'path': '/document-search', 'component': DocumentSearchComponent, 'exact': true, 'private': false },
    { 'path': '/cart', 'component': CartComponent, 'exact': true, 'private': false },
    { 'path': '/policy/documents', 'component': PublicPolicies, 'exact': true, 'private': false },
    { 'path': '/policy/document/view', 'component': ViewPolicy, 'exact': true, 'private': false },
    { 'path': '/checkout', 'component': CheckoutComponent, 'exact': true, 'private': true },
    { 'path': '/orders', 'component': OrderComponent, 'exact': true, 'private': true },
    { 'path': '/order-detail/:id', 'component': OrderDetailsComponent, 'exact': true, 'private': true },
    { 'path': '/dashboard', 'component': DashboardComponent, 'exact': true, 'private': true },
    { 'path': '/documents/recent-updates', 'component': RecentUpdatesComponent, 'exact': true, 'private': true },
    { 'path': '/documents/compare/', 'component': DocumentCompareComponent, 'exact': true, 'private': true },
    { 'path': '/saved-documents', 'component': SAVED_DOCUMENTS, 'exact': true, 'private': true },
    { 'path': '/create-new-documents', 'component': CREATE_NEW_SAVED_DOCS, 'exact': true, 'private': true },
    { 'path': '/documents', 'component': DocumentListComponent, 'exact': true, 'private': true },
    { 'path': '/documents/editor/', 'component': DocumentEditorComponent, 'exact': true, 'private': true },
    { 'path': '/settings', 'component': SettingsComponent, 'exact': true, 'private': true },
    { 'path': '/subscriptions', 'component': UserSubscriptionListComponent, 'exact': true, 'private': true },
    { 'path': '/invoice', 'component': ViewInvoiceDetails, 'exact': true, 'private': true },
    { 'path': '/subscription/pay', 'component': SubscriptionPayComponent, 'exact': true, 'private': true },
    { 'path': '/users', 'component': UsersListComponent, 'exact': true, 'private': true },
    { 'path': '/users/add', 'component': UserAddComponent, 'exact': true, 'private': true },
    { 'path': '/users/edit', 'component': UserEditComponent, 'exact': true, 'private': true },
    { 'path': '/users/view', 'component': ViewUserComponent, 'exact': true, 'private': true },
    { 'path': '/users/activity', 'component': USERSACTIVTYCOMPONENT, 'exact': true, 'private': true },
    { 'path': '/users/deleted-list', 'component': UserDeleteComponent, 'exact': true, 'private': true },
    // { 'path': '/policy-documents', 'component': EmployeePolicyDocuments, 'exact': true, 'private': true },
    { 'path': '/groups', 'component': EmployeeGroups, 'exact': true, 'private': true },
    { 'path': '/group/add', 'component': AddGroupComponent, 'exact': true, 'private': true },
    { 'path': '/group/edit', 'component': EditGroupComponent, 'exact': true, 'private': true },
    { 'path': '/group/view', 'component': ViewGroupComponent, 'exact': true, 'private': true },
    { 'path': '/policies', 'component': EmployeePolicies, 'exact': true, 'private': true },
    { 'path': '/policies/create', 'component': AddPolicy, 'exact': true, 'private': true },
    { 'path': '/policies/multi/create', 'component': AddMultiPolicy, 'exact': true, 'private': true },
    { 'path': '/policies/edit', 'component': EditPolicy, 'exact': true, 'private': true },
    { 'path': '/index', 'component': IndexComponent, 'exact': true, 'private': true },
    { 'path': '/view/:mainpath/:subpath/:name', 'component': PDF_EXPIRE_DOCUMENT, 'exact': true, 'private': false },
    { 'path': '/profile', 'component': New_Profile, 'exact': true, 'private': true },
    { 'path': '/order/history', 'component': OrderHistory, 'exact': true, 'private': true },
    { 'path': '/contact-us', 'component': ContactUs, 'exact': true, 'private': false },
    { 'path': '/about-us', 'component': AboutUs, 'exact': true, 'private': false },
    { 'path': '/features', 'component': Features, 'exact': true, 'private': false },
    { 'path': '/pricing', 'component': Pricing, 'exact': true, 'private': false },
    { 'path': '/pricing/all-in-one', 'component': AllinOnePricing, 'exact': true, 'private': false },
    { 'path': '/pricing/care-management', 'component': CareManagementPricing, 'exact': true, 'private': false },
    { 'path': '/case-studies', 'component': CaseStudies, 'exact': true, 'private': false },
    { 'path': '/security', 'component': Security, 'exact': true, 'private': false },
    { 'path': '/updates', 'component': Updates, 'exact': true, 'private': false },
    { 'path': '/roadmap', 'component': RoadMap, 'exact': true, 'private': false },
    { 'path': '/knowledge', 'component': Knowledge, 'exact': true, 'private': false },
    { 'path': '/document-updates', 'component': DocumentUpdate, 'exact': true, 'private': false },
    { 'path': '/document/management/renewal', 'component': DocManagementPayment, 'exact': true, 'private': true },
    { 'path': '/download/sample/documents', 'component': FreeDocumentDownload, 'exact': true, 'private': false },
    { 'path': '/publishedpolicies', 'component': PublishedPolicies, 'exact': true, 'private': true },
    { 'path': '/documents/need-review', 'component': NeedReviewList, 'exact': true, 'private': true },
    { 'path': '/documents/uptodate', 'component': UptoDateDocuments, 'exact': true, 'private': true },
    // { 'path': '/history', 'component': HistoryList, 'exact': true, 'private': true },
    { 'path': '/employees', 'component': EmployeesListComponent, 'exact': true, 'private': true },
    { 'path': '/employee/add', 'component': AddEmployeeComponent, 'exact': true, 'private': true },
    { 'path': '/employee/edit', 'component': EditEmployeeComponent, 'exact': true, 'private': true },
    { 'path': '/employee/view', 'component': ViewEmployeeComponent, 'exact': true, 'private': true },
    { 'path': '/deleted/employees', 'component': DeletedEmployeesComponent, 'exact': true, 'private': true },
    { 'path': '/view/Document/:slug', 'component': ViewDocument, 'exact': true, 'private': false },
    { 'path': '/reference/:id', 'component': ReferenceDocView, 'exact': true, 'private': true },
    { 'path': '/myfiles', 'component': MyfilesComponent, 'exact': true, 'private': true },
    { 'path': '/myfiles/editor', 'component': MyfileEditorComponent, 'exact': true, 'private': true },
    { 'path': '/myfiles/details', 'component': MyfileDetailsComponent, 'exact': true, 'private': true },
    { 'path': '/myDocuments', 'component': MyDocumentsComponent, 'exact': true, 'private': true },
    { 'path': '/myDocuments/editor', 'component': MyDocumentsEditorComponent, 'exact': true, 'private': true },
    { 'path': '/myDocuments/details', 'component': MyDocumentsDetailsComponent, 'exact': true, 'private': true },
    { 'path': '/deleted-documents', 'component': DocumentBinComponent, 'exact': true, 'private': true },


    //doc sign
    { 'path': '/document/sign', 'component': DocSign, 'exact': true, 'private': false },
    { 'path': '/document/sign/success', 'component': DocSignSuccess, 'exact': true, 'private': false },
    //FAQ
    { 'path': '/faq', 'component': FAQComponent, 'exact': true, 'private': false },
    //Documentation
    { 'path': '/systemdocumentation', 'component': Documentation, 'exact': true, 'private': false },
    { 'path': '/documentlibrary', 'component': DocumentLibrary, 'exact': true, 'private': false },

    //price Simplifies Compliance
    { 'path': '/readytousepolicies/:id', 'component': ReadyTousePolicy, 'exact': true, 'private': false },
    { 'path': '/uptodatedocuments/:id', 'component': UptoDateDocumentsPricing, 'exact': true, 'private': false },
    { 'path': '/flexiblepricing/:id', 'component': FlexiblePricing, 'exact': true, 'private': false },

    //Couse
    { 'path': '/course', 'component': CourseComponent, 'exact': true, 'private': false },

    //Form Builder
    { 'path': '/formslist', 'component': FormList, 'exact': true, 'private': false },
    { 'path': '/formbuilder', 'component': FormBuilder, 'exact': true, 'private': false },
    { 'path': '/webform', 'component': companyForm, 'exact': true, 'private': false },
    { 'path': '/webform/fill', 'component': WebForm, 'exact': true, 'private': false },
    { 'path': '/webform/completed', 'component': successPage, 'exact': true, 'private': false },

    { 'path': '/course/checkout', 'component': CourseCheckout, 'exact': true, 'private': false },
    { 'path': '/checklist-newprovider', 'component': ChecklistNew, 'exact': true, 'private': false },




    { 'path': '/staff', 'component': StaffListRemote, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/staff/view', 'component': StaffViewRemote, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/staff/add', 'component': StaffAddEditRemote, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/staff/edit', 'component': StaffAddEditRemote, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },

    // To preview the ai code.
    { 'path': '/preview', 'component': PreviewAICode, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },


    // Client Routing,,,

    { 'path': '/clients', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/add', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/edit', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },


    // Domiciliary care assessment Routing
    { 'path': '/clients/assesment/personalcare', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/medicalcare', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/everydayactivity', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/medication', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/end_of_life', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/social_support', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/environmental', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/covid19', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/financial', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/service_review', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/nutrition_hydration', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/waterlow', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/feedback', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },

    { 'path': '/clients/assesment/personalcare/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/medicalcare/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/everydayactivity/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/medication/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/end_of_life/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/social_support/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/environmental/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/covid19/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/financial/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/service_review/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/nutrition_hydration/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/waterlow/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/feedback/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },


    // supported living assessments routing
    { 'path': '/clients/assesment/housing_accommodations', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/independent_living', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/financial_Management', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/health_Management', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/personal_safety', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },

    { 'path': '/clients/assesment/housing_accommodations/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/independent_living/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/financial_Management/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/clients/assesment/personal_safety/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },



    // Visits & Schedule
    { 'path': '/visits', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/visits/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/careplan/edit', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/careplans', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/careplans/form', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/careplans/view', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },

    // Daily Logs
    { 'path': '/daily-logs', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/incidents', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/outcomes', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },

    // medication & eMAR 
    { 'path': '/medication', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },
    { 'path': '/medication/emar', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },


    // Time Sheets
    { 'path': '/timesheet', 'component': RemoteApp, 'exact': true, 'private': true, hasHeader: true, hasSidebar: true },






















    { 'path': '*', 'component': NoMatchComponent, 'exact': true, 'private': false },




    // { 'path': '/user/subscription', 'component': ViewSubscriptions, 'exact': true, 'private': true },
    // { 'path': '/signup', 'component': RegisterComponent, 'exact': true, 'private': false },
    // { 'path': '/profile', 'component': ProfileComponent, 'exact': true, 'private': true },
    // { 'path': '/subscription-detail/:slug', 'component': SubscriptionDetailComponent, 'exact': true, 'private': false },
    // { 'path': '/cart', 'component': CartComponent, 'exact': true, 'private': true },
    // { 'path': '/subscriptions', 'component': UserSubscriptionListComponent, 'exact': true, 'private': true },
    // { 'path': '/faq', 'component': FAQComponent, 'exact': true, 'private': false },
    // { 'path': '/resetpassword/:id/:resetcode', 'component': resetpassword, 'exact': true, 'private': false },
    // { 'path': '/document/preview', 'component': DocumentPreview, 'exact': true, 'private': false },

];

export default routes;